<template>
  <div>
        <Banner :classType="7" />


    <div class="wrap lawBox" v-html="content">
      
    </div>
  </div>
</template>

<script>
import Banner from "@/views/components/Banner";

export default {
  data() {
    return {
      content: "",
    };
  },
   components: {

    Banner,
  },
  methods: {
    getData() {
      this.$api
        .pageCon({
          Type: "2",
        })
        .then((res) => {
          this.content= res.Value.Content
        });
    },
  },
  mounted(){
    this.getData()
  }
};
</script>

<style lang="scss">
.lawBox {
  padding: 50px 0;
  p {
    padding: 10px 0
  }
}
</style>